// extracted by mini-css-extract-plugin
export var arrows = "_2i-6";
export var decrementer = "_2i-a";
export var disabled = "_2i-4";
export var error = "_2i-1";
export var hiddenText = "_2i-b";
export var incrementer = "_2i-9";
export var input = "_2i-8";
export var inputWrapper = "_2i-0";
export var leadingIcon = "_2i-c";
export var readonly = "_2i-3";
export var regular = "_2i-7";
export var small = "_2i-5";
export var warning = "_2i-2";